export default "__VITE_ASSET__BXY0T8V0__"